import {
  Layouts,
  registerLayout as oRegisterLayout,
  GridLayout,
  RandomLayout,
  CircularLayout,
  DagreLayout,
  RadialLayout,
  ConcentricLayout,
  MDSLayout,
  FruchtermanGPULayout,
  FruchtermanLayout,
  GForceLayout,
  GForceGPULayout,
  ComboForceLayout,
  ForceAtlas2Layout,
} from '@antv/layout'
import { ForceLayout } from '@yuntu/layout'

oRegisterLayout('grid', GridLayout)
oRegisterLayout('random', RandomLayout)
oRegisterLayout('force', ForceLayout)
oRegisterLayout('circular', CircularLayout)
oRegisterLayout('dagre', DagreLayout)
oRegisterLayout('radial', RadialLayout)
oRegisterLayout('concentric', ConcentricLayout)
oRegisterLayout('mds', MDSLayout)
oRegisterLayout('fruchterman', FruchtermanLayout)
oRegisterLayout('fruchterman-gpu', FruchtermanGPULayout)
oRegisterLayout('gForce', GForceLayout)
oRegisterLayout('gForce-gpu', GForceGPULayout)
oRegisterLayout('comboForce', ComboForceLayout)
oRegisterLayout('forceAtlas2', ForceAtlas2Layout)

Layouts.force = ForceLayout

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const registerLayout = (name: string, layoutOverride: any) => {
  layoutOverride.isCustomLayout = true
  Layouts[name] = oRegisterLayout(name, layoutOverride)
}

export { Layouts, registerLayout }
